module.exports = __webpack_public_path__ + "img/2.7fb5eee2.webp";